import React from "react";
import { FaPrint, FaSearch, FaTrash } from "react-icons/fa";
import { formatRupiah } from "../../../../../helper/formatNumber";

import "./salesClinicData.css";
import { formatDateTransactionDetail } from "../../../../../helper/formatDate";

const SalesClinicData = ({
  transactionDate,
  transactionData,
  onClickPrintTransaction,
  onOpenDetailTransaction,
  onDeleteClinicTransaction,
}) => {
  const getBackgroundColor = (paymentMethod) => {
    switch (paymentMethod) {
      case "CASH":
        return "#F0F0F0";
      case "TRANSFER":
        return "#FFF9C4";
      case "DEBIT":
        return "#C8E6C9";
      case "QRIS":
        return "#FFE0B2";
      case "KARTU KREDIT":
        return "#BBDEFB";
      case "REKANAN":
        return "#D1C4E9";
      default:
        break;
    }
  };
  const userData = JSON.parse(localStorage.getItem("user_data"));

  return (
    <div className="sales-clinic-data-container">
      <h4>Transaksi pada {transactionDate}</h4>
      <div className="sales-clinic-data-table-container">
        {transactionData.map((data, index) => (
          <div
            className="sales-clinic-data-row"
            key={data.medical_transaction_invoice_number}
          >
            <p
              className="sales-clinic-data-column"
              style={{
                backgroundColor: getBackgroundColor(data.payment_method),
              }}
            >
              {data.medical_transaction_invoice_number}
            </p>
            <p className="sales-data-column">
              {formatDateTransactionDetail(data.medical_transaction_date)}
            </p>
            <p className="sales-clinic-data-column">
              <b>{formatRupiah(data.total_transaction)}</b>
            </p>
            {data.patient_name === "" ? (
              <p className="sales-data-column">-</p>
            ) : (
              <p className="sales-data-column">{data.patient_name}</p>
            )}
            {data.doctor_name === "" ? (
              <p className="sales-data-column">-</p>
            ) : (
              <p className="sales-data-column">{data.doctor_name}</p>
            )}
            <p className="sales-clinic-data-column">{data.staff_name}</p>
            <p className="sales-clinic-data-column">
              {data.staff_shift === 0 ? "Pagi" : "Siang"}
            </p>
            <div className="sales-clinic-data-actions">
              {typeof onClickPrintTransaction === "function" && (
                <button
                  className="sales-clinic-data-action-button"
                  onClick={() => onClickPrintTransaction(data)}
                >
                  <FaPrint />
                </button>
              )}
              <button
                className="sales-clinic-data-action-button"
                onClick={() => onOpenDetailTransaction(data)}
              >
                <FaSearch />
              </button>
              {typeof onDeleteClinicTransaction === "function" &&
                userData &&
                ["ADMIN", "MANAGER", "SUPERVISOR"].includes(
                  userData.staff_system_role
                ) && (
                  <button
                    className="sales-clinic-data-action-button"
                    onClick={() =>
                      onDeleteClinicTransaction(data.medical_transaction_id)
                    }
                  >
                    <FaTrash />
                  </button>
                )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SalesClinicData;
